/**
 * Popup do clique num eco do radar: só a faixa de valor da classe lida
 * ("30–33 dBZ" ou "5–10 mm/h"). Radar, horário da varredura e fonte já estão
 * no painel e nos créditos; repetidos no popup, poluíam o mapa.
 */
import { ProximosDiasAqui } from '../previsao/ProximosDiasAqui';
import { DEF_PRODUTO, rotuloClasse, type Produto } from './produtos';

export function RadarPopup(props: {
  produto: Produto;
  /** Índice da classe na legenda, ou null (cor fora da paleta oficial). */
  classe: number | null;
  /** Onde foi o toque (lon, lat) — para "Próximos dias aqui". */
  lonLat?: [number, number];
}) {
  const def = DEF_PRODUTO[props.produto];
  return (
    <div>
      <div className="font-semibold text-white tabular-nums">{props.classe === null ? 'Fora da legenda' : rotuloClasse(def, props.classe)}</div>
      {props.lonLat && <ProximosDiasAqui lon={props.lonLat[0]} lat={props.lonLat[1]} />}
    </div>
  );
}
